import React, { useState } from 'react';
import Alert from 'components/Alert';
import OnboardingLayout from 'components/OnboardingLayout';
import { useGlobalState } from 'hooks/useGlobalState';
import { signupStatus } from 'utils/constants';

import OnboardingForm from './components/OnboardingForm';
import styles from './Onboarding.module.scss';

export default function Onboarding() {
  const [{ signup }] = useGlobalState();
  const [apiError, setApiError] = useState(null);

  return (
    <OnboardingLayout
      promptEnabled={[signupStatus.started, signupStatus.error].includes(
        signup.status,
      )}
    >
      {apiError && (
        <Alert
          error
          role="alert"
          className={styles.alertBox}
          data-testid="onboarding_alert"
        >
          <span>{apiError}</span>
        </Alert>
      )}
      <h1 className={styles.h1}>Let's finish setting things up</h1>
      <h2 className={styles.h2}>
        You're just a few steps away from starting to use xMatters
      </h2>
      <OnboardingForm signupData={signup.data} setApiError={setApiError} />
    </OnboardingLayout>
  );
}
